// SARKY: Billy's approved rule -- if the previously selected Size is no
// longer sellable for a newly selected Color, the Size selection must be
// CLEARED (never left checked-but-sold-out, and never auto-replaced with
// any other Size). This does not touch Shopify's own availability/variant
// resolution at all: assets/variant-picker.js is completely unmodified,
// and this only reacts to its own 'variant:update' event (bubbles to
// document, so this always runs after variant-picker.js's own morph has
// already refreshed every option value's aria-disabled state for the new
// Color -- see snippets/variant-main-picker.liquid and the existing
// assets/sarky-variant-picker-disabled-guard.js, which already stops a
// disabled Size from ever being checked by a direct click in the first
// place. Because of that guard, the ONLY way this listener can ever find
// a checked-but-aria-disabled Size input is when a *different* option
// (Color) just changed underneath a still-checked Size -- so no special
// casing is needed here to tell "caused by Color" apart from "caused by
// Size": a Size click can never leave a disabled input checked to begin
// with.
//
// Why this can't just be "wait for a null-resource variant:update event"
// (the pattern assets/sarky-sticky-clean-summary.js already uses for a
// genuinely incomplete selection): empirically verified against this
// theme's own product.selected_or_first_available_variant Liquid object --
// even a request carrying ONLY the Color option value (Size entirely
// omitted) still resolves to a real, specific variant (Shopify's own
// documented "first available" fallback for that property), never null.
// So after clearing the Size input here, this reaches into the same two
// places assets/product-form.js's own #onVariantUpdate touches for a truly
// null resource (clearing the hidden variant id, disabling the
// add-to-cart-component(s)) and does the same for the sticky bar's own
// text -- explicitly, using only public methods/DOM already exposed by
// those unmodified files, since no null-resource event will arrive on its
// own to trigger their existing handling of that state.
document.addEventListener('variant:update', (event) => {
  const productId = event.detail.data && event.detail.data.productId;
  if (!productId) return;

  const picker = document.querySelector(`variant-picker[data-product-id="${productId}"]`);
  if (!picker) return;

  const nonColorFieldsets = Array.from(picker.querySelectorAll('fieldset')).filter(
    (fieldset) => !fieldset.classList.contains('variant-option--swatches')
  );

  let clearedAny = false;
  for (const fieldset of nonColorFieldsets) {
    const checkedInput = fieldset.querySelector('input:checked');
    if (checkedInput && checkedInput.getAttribute('aria-disabled') === 'true') {
      checkedInput.checked = false;
      clearedAny = true;
    }
  }

  if (!clearedAny) return;

  const productForm = document.querySelector(`product-form-component[data-product-id="${productId}"]`);
  if (productForm) {
    const idInput = productForm.querySelector('input[name="id"]');
    if (idInput) idInput.value = '';

    productForm.querySelectorAll('add-to-cart-component').forEach((addToCart) => {
      if (typeof addToCart.disable === 'function') addToCart.disable();
    });
  }

  const stickyBar = document.querySelector(`sticky-add-to-cart[data-product-id="${productId}"]`);
  if (stickyBar) {
    stickyBar.dataset.currentVariantId = '';

    const variantTextEl = stickyBar.querySelector('.sticky-add-to-cart__variant');
    if (variantTextEl) {
      variantTextEl.textContent = '';
      const prompt = document.createElement('button');
      prompt.type = 'button';
      prompt.className = 'sarky-sticky-select-size';
      prompt.textContent = 'Select Size';
      variantTextEl.appendChild(prompt);
    }

    const stickyButton = stickyBar.querySelector('.sticky-add-to-cart__button');
    if (stickyButton) stickyButton.disabled = true;
  }
});
